import React, {cloneElement} from 'react'
import ReactDOM from 'react-dom';

import Menu from './Menu.jsx';

class SubMenu extends React.Component {
    componentDidMount () {
        this.popup = document.createElement("div");
        this.popup.style.display = "none";
        this.popup.style.position = "absolute";
        this.popup.className = "tde-dropdown-menu";
        this.popupRoot = ReactDOM.createRoot(this.popup);
        // this.popup.onmouseenter = this.onChildMouseEnter;
        // this.popup.onmouseleave = this.onChildMouseLeave;
    }

    componentDidUpdate () {
        if(this.props.container && !this.isAddedToContainer) {
            this.isAddedToContainer = true;
            this.props.container.appendChild(this.popup);
        }
        this._renderLayer();
        this.repositionPopup();
    }

    componentWillUnmount () {
        // asynchronously unmounting root
        if(this.popupRoot) {
            this.popupRoot.current = undefined;
        }
        setTimeout(()=>{
            this.popupRoot?.unmount();
            this.popupRoot = null;
        });
        if(this.props.container && this.isAddedToContainer ) {
            this.props.container.removeChild(this.popup);
            this.isAddedToContainer = false;
        }
    }

    _renderLayer () {
        var children = React.Children.map(this.props.children, child => {
            if(child && child.type == SubMenu) {
                child = cloneElement(child, {
                    opened: this.props.opened,
                    setOpen: this.props.setOpen,
                });
            }
            return child;
        });

        this.popupRoot?.render(
            <div onMouseEnter={this.onMouseOver} onMouseLeave={this.onMouseOut} ref={el => this._innerWrapper = el}>
                <div className="tde-submenu-wrapper tde-bg-color">
                    {this.props.tip && this.props.mode !== 'elem' && <div className="tde-title-tip">{this.props.tip}</div>}
                    { this.isOpened &&
                        <Menu
                            direction="vertical"
                            tabPressed={(isShifted) => this.props.tabPressed(isShifted, this.refs._thisEle)}
                            onMouseEnter={this.onChildMouseEnter}
                            onMouseLeave={this.onChildMouseLeave}
                            >
                            {children}
                        </Menu>
                    }
                </div>
            </div>
        );
    }

    repositionPopup = () => {
        if(!this.props.container) {
            return;
        }
        var childPos = ReactDOM.findDOMNode(this).getBoundingClientRect();
        var parentPos = ReactDOM.findDOMNode(this.props.container).getBoundingClientRect();
        var dataLevel = this.props['data-level'];
        var parentPosition = '';

        if(dataLevel >= 1) {
            var childOffset = {
                top: childPos.top - parentPos.top,
                left: childPos.left - parentPos.left + childPos.width,
                bottom: parentPos.bottom - childPos.bottom,
                right: parentPos.right - childPos.right + childPos.width
            }

            if(this.props.inputType === 'dropdown') {
                this.popup.style.left = 'auto';
                this.popup.style.bottom = 'auto';
                this.popup.style.right = (parentPos.right - childPos.right) + 'px';
                this.popup.style.top = (childOffset.top + childPos.height) + 'px';
                this.popup.style.maxHeight = (parentPos.height - childOffset.top - 50) + 'px';
                this.popup.style.width = this.props.reducecasecardwidth == 'true' ? '155px':'225px';
                return;
            }

            if(childOffset.top < parentPos.height/2) {
                childOffset.top -= 10;
                this.popup.style.top = childOffset.top + 'px';
                this.popup.style.bottom = 'auto';
                this.popup.style.maxHeight = (parentPos.height - childOffset.top - 20) + 'px';
            } else {
                childOffset.bottom -= 10;
                this.popup.style.top = 'auto';
                this.popup.style.bottom = childOffset.bottom + 'px';
                this.popup.style.maxHeight = (parentPos.height - childOffset.bottom - 20) + 'px';
            }

            if(childOffset.left + 250 < parentPos.width) {
                this.popup.style.left = childOffset.left + 'px';
                this.popup.style.right = 'auto';
                parentPosition = 'left';
            } else {
                this.popup.style.right = childOffset.right + 'px';
                this.popup.style.left = 'auto';
                parentPosition = 'right';
            }
        } else {
            var childOffset = {
                top: childPos.top + childPos.height - parentPos.top,
                left: childPos.left - parentPos.left,
                right: parentPos.right - childPos.right
            }
            this.popup.style.top = childOffset.top + 'px';
            if(childOffset.left + 250 < parentPos.width) {
                childOffset.left -= 10;
                this.popup.style.left = childOffset.left + 'px';
                this.popup.style.right = 'auto';
            } else {
                childOffset.right -= 10;
                this.popup.style.right = childOffset.right + 'px';
                this.popup.style.left = 'auto';
            }
            parentPosition = 'top';

            this.popup.style.maxHeight = (parentPos.height - childOffset.top - 20) + 'px';
        }

        var _timeoutTime = this._innerWrapper? 0: 500;
        setTimeout(() => {
            if(this._innerWrapper) {
                this._innerWrapper.style.paddingTop = this._innerWrapper.style.paddingBottom =
                    this._innerWrapper.style.paddingRight = this._innerWrapper.style.paddingLeft = '10px';
                switch(parentPosition) {
                    case 'top':
                        this._innerWrapper.style.paddingTop = 0;
                    break;
                    case 'left':
                        this._innerWrapper.style.paddingLeft = 0;
                    break;
                    case 'right':
                        this._innerWrapper.style.paddingRight = 0;
                    break;
                    case 'bottom':
                        this._innerWrapper.style.paddingBottom = 0;
                    break;
                }
            }
        }, _timeoutTime);
    }

    onMouseOver = () => {
        this.props.setOpen(1, this.props.id);
    }

    onChildMouseEnter = () => {
        this.props.setOpen(1, this.props.id);
    }

    onChildMouseLeave = (e) => {
        if(e.key === 'Escape') {
            this.refs._thisEle.focus();
            this.props.setOpen(0, this.props.id);
        } else {
            this.props.setOpen(-1, this.props.id);
        }
    }

    onMouseOut = () => {
        this.props.setOpen(-1, this.props.id);
    }

    handleClick = (e) => {
        e.preventDefault();
        this.open();
    }

    open() {
        this.props.setOpen(1, this.props.id);
        setTimeout(() => {
            // To focus the first li
            let menu = this.popup.getElementsByClassName('tde-menu');
            if(menu.length > 0) {
                if(menu[0].children.length > 0) {
                    menu[0].children[0].focus();
                }
            }
        }, 200);
    }

    render () {
        const { label, children, className, direction, opened, setOpen, tabPressed, container, inputType, onKeyDown, tip, ...props } = this.props;
        this.isOpened = false;
        if(this.popup) {
            if(opened.indexOf(props.id) >= 0) {
                this.popup.style.display = "block";
                this.isOpened = true;
            } else {
                this.popup.style.display = "none";
            }
            /*
            if(direction === 'horizontal') {
                this.popup.classList.add('tde-arrow');
            } else {
                this.popup.classList.remove('tde-arrow');
            }
            */
        }

        let dynamicProps = {
            onClick: this.handleClick,
            onKeyDown: (e) => { // Trigger the click event from the keyboard
                var code = e.which;
                // 13 = Return, 32 = Space
                if ((code === 13) || (code === 32)) {
                    this.handleClick(e);
                } else {
                    onKeyDown && onKeyDown(e);
                }
            }
        };
        if(!inputType) {
            dynamicProps = {
                ...dynamicProps,
                onMouseEnter: this.onMouseOver,
                onMouseLeave: this.onMouseOut
            };
        }
        return (
            <div ref="_thisEle"
                {...dynamicProps}
                tabIndex={0}
                aria-expanded={this.isOpened}
                role="menuitem"
                title={tip}
                aria-label="expand-menu"
                className={`tde-menu-item tde-dropdown-trigger ` + (className || '') + (this.isOpened? ' tde-opened':'')} {...props}>
                {label}
            </div>
        )
    }
}

export default SubMenu
